import { customElement } from 'lit/decorators.js'

import { OxGristEditorValueMap } from '@operato/grist-editor/ox-grist-editor-value-map.js'

@customElement('color-map-editor')
export class ColorMapEditor extends OxGristEditorValueMap {
  get options() {
    const overidable = this.column.record?.options || {}

    return {
      name: `Color Map : ${this.record.name}`,
      valuetype: 'color',
      objectified: true,
      ...overidable
    }
  }
}
